import * as React from 'react';
import type { ToggleButtonProps } from '../ToggleButton';

export interface ComposerSidebarItem {
  id: string | number;
  label: string;
  disabled?: boolean;
  icon?: any;
  sectionTitle?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export interface ComposerSidebarProps {
  dataHook?: string;
  labelPlacement?: ToggleButtonProps['labelPlacement'];
  labelTooltipProps?: ToggleButtonProps['tooltipProps'];
  size?: string;
  className?: string;
  selectedId?: number | string;
  items?: ComposerSidebarItem[];
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export default class ComposerSidebar extends React.PureComponent<ComposerSidebarProps> {}
